import Vue from 'vue';

import link from './a.vue';
Vue.component('mag-a', link);